import type {ReactNode} from 'react';
import {AppIcon, FaCalendarIcon, FaCheckCircleIcon, FaLocationIcon} from '../icon';

// Listing-card meta rows always render their glyph at the `sm` token; these
// pre-sized elements are the shared source for the location + publish-date rows.

export const LOCATION_ICON: ReactNode = <AppIcon icon={FaLocationIcon} sx={{fontSize: '0.875em'}} aria-hidden />;

export const CALENDAR_ICON: ReactNode = <AppIcon icon={FaCalendarIcon} sx={{fontSize: '0.875em'}} aria-hidden />;

export function statusBadgeIcon(key: string): ReactNode | undefined {
  if (key === 'delivered_phase') {
    return <AppIcon icon={FaCheckCircleIcon} aria-hidden />;
  }
  return undefined;
}
